module.exports = __webpack_public_path__ + "Server-Healthy.TentaclePassive.588dcaddf80ba6632e75b2651a71c15f.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Healthy.TentaclePassive.png
// module id = 1253
// module chunks = 1